/* Falfello Mart Shopify theme: interactions
   Uses Shopify's AJAX Cart API + Section Rendering API, so the cart is the real Shopify cart. */
(function () {
  'use strict';
  var FM = window.FM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- Money (uses the store's money format, e.g. "Dhs. {{amount}}") ---------- */
  function formatMoney(cents) {
    var fmt = String(FM.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', n = (cents || 0) / 100;
    var fix = function (d, t, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); };
    var map = {
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.')
    };
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, map[key] || map.amount);
  }

  /* ---------- Toast ---------- */
  var tt;
  function toast(msg, sub, isError) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = '<div class="t"><b>' + (isError ? '' : '<svg class="ic"><use href="#i-check"/></svg>') + esc(msg) + '</b>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</div>';
    t.classList.add('show'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('show'); }, 3500);
  }

  /* ---------- Drawers ---------- */
  var lastFocus;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    closeAll(true); lastFocus = document.activeElement;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    $('#ov').classList.add('open'); document.body.style.overflow = 'hidden';
    var c = $('.dclose', d); if (c) c.focus();
  }
  function closeAll(silent) {
    $$('.drawer.open').forEach(function (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    var ov = $('#ov'); if (ov) ov.classList.remove('open');
    document.body.style.overflow = '';
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Cart ---------- */
  function setCounts(cart) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = cart.item_count; b.classList.toggle('zero', !cart.item_count); });
    $$('[data-cart-total]').forEach(function (t) { t.textContent = formatMoney(cart.total_price); });
  }
  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('.shopify-section'), cur = document.getElementById('shopify-section-cart-drawer');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function refreshCart() {
    return fetch(FM.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(setCounts);
  }
  function addToCart(form) {
    var btn = $('[type=submit]', form) || $('button', form);
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(FM.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'This item could not be added', '', true); return; }
        renderDrawer(res.j.sections);
        return refreshCart().then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          openDrawer('cart');
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  function changeLine(key, qty) {
    var body = $('#shopify-section-cart-drawer .dbody'); if (body) body.style.opacity = '.5';
    return fetch(FM.cartChangeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart.sections); setCounts(cart);
      if (cart.status) toast(cart.description || 'Quantity not available', '', true);
    });
  }

  /* ---------- Wishlist (saved in the browser) ---------- */
  function getWish() { try { return JSON.parse(localStorage.getItem('fm_wish') || '[]'); } catch (e) { return []; } }
  function setWish(w) { try { localStorage.setItem('fm_wish', JSON.stringify(w)); } catch (e) {} paintWish(); }
  function paintWish() {
    var w = getWish();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', w.indexOf(b.dataset.wish) > -1); });
    $$('[data-wish-count]').forEach(function (b) { b.textContent = w.length; b.classList.toggle('zero', !w.length); });
  }
  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var w = getWish(), empty = $('[data-wishlist-empty]');
    if (!w.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(w.map(function (h) {
      return fetch(FM.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      grid.innerHTML = list.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        var single = p.variants.length === 1;
        return '<article class="pcard"><div class="pimg"><a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button class="wish" type="button" data-wish="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove from wishlist"><svg class="ic"><use href="#i-heart"/></svg></button></div>' +
          '<div class="pbody"><p class="pcat">' + esc(p.type) + '</p><h3 class="pname"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' +
          '<div class="pprice"><strong>' + formatMoney(p.price) + '</strong>' + (p.compare_at_price > p.price ? '<s>' + formatMoney(p.compare_at_price) + '</s>' : '') + '</div>' +
          (p.available && single ? '<form action="' + FM.cartAddUrl + '" method="post" class="padd" data-product-form><input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1"><button class="btn btn-dark btn-block" type="submit"><svg class="ic"><use href="#i-bag"/></svg>Add to cart</button></form>'
            : '<a class="btn btn-dark btn-block padd" href="' + p.url + '">' + (p.available ? 'Choose options' : 'Sold out') + '</a>') +
          '</div></article>';
      }).join('');
    });
  }

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-open]'))) { e.preventDefault(); openDrawer(el.dataset.open); return; }
    if (t.closest('[data-close]')) { closeAll(); return; }
    if ((el = t.closest('[data-cart-change]'))) { e.preventDefault(); changeLine(el.dataset.key, parseInt(el.dataset.qty, 10)); return; }
    if ((el = t.closest('[data-wish]'))) {
      e.preventDefault();
      var w = getWish(), h = el.dataset.wish, i = w.indexOf(h);
      if (i > -1) { w.splice(i, 1); toast('Removed from wishlist'); } else { w.push(h); toast('Saved to wishlist'); }
      setWish(w);
      if ($('[data-wishlist-grid]')) renderWishlistPage();
      return;
    }
    if ((el = t.closest('[data-qty-step]'))) {
      var input = $('input', el.closest('.qtybox'));
      var min = parseInt(input.min || '1', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(el.dataset.qtyStep, 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (t.closest('[data-toggle-facets]')) { $('.facets').classList.toggle('open'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-product-form]');
    if (f && window.fetch) { e.preventDefault(); addToCart(f); }
  });

  /* ---------- Collection filters & sorting ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-facets] input[type=checkbox]')) t.form.submit();
    if (t.matches('[data-sort]')) {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  /* ---------- Hero slider ---------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach(function (sl) {
      if (sl._init) return; sl._init = true;
      var slides = $$('.slide', sl), dots = $$('.dot', sl), i = 0, timer;
      var speed = (parseInt(sl.dataset.speed, 10) || 6) * 1000, auto = sl.dataset.autoplay === 'true';
      if (slides.length < 2) return;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k !== i); });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      }
      function start() { clearInterval(timer); if (auto && !reduce) timer = setInterval(function () { go(i + 1); }, speed); }
      var p = $('[data-prev]', sl), nx = $('[data-next]', sl);
      if (p) p.addEventListener('click', function () { go(i - 1); start(); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      sl.addEventListener('mouseenter', function () { clearInterval(timer); });
      sl.addEventListener('mouseleave', start);
      var x0 = null;
      sl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      sl.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) { go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
      sl._go = go;
      go(0); start();
    });
  }

  /* ---------- Announcement: rotation + dispatch countdown (Dubai time, UTC+4) ---------- */
  function initAnnouncement() {
    var m = $$('[data-rotate] > span');
    if (m.length > 1) { var k = 0; setInterval(function () { m[k].classList.remove('on'); k = (k + 1) % m.length; m[k].classList.add('on'); }, 4000); }
    var els = $$('[data-cutoff]'); if (!els.length) return;
    function tick() {
      var d = new Date(), dxb = new Date(d.getTime() + d.getTimezoneOffset() * 6e4 + 4 * 36e5), cut = new Date(dxb);
      cut.setHours(FM.cutoff || 14, 0, 0, 0);
      var diff = cut - dxb;
      els.forEach(function (el) {
        if (!el.dataset.fallback) el.dataset.fallback = el.innerHTML;
        if (diff > 0) { var h = Math.floor(diff / 36e5), mi = Math.floor(diff % 36e5 / 6e4); el.innerHTML = 'Order within <b>' + (h ? h + 'h ' : '') + mi + 'm</b> for same-day dispatch'; }
        else el.innerHTML = el.dataset.fallback;
      });
    }
    tick(); setInterval(tick, 30000);
  }

  /* ---------- Product page: variants + gallery ---------- */
  function initProduct() {
    var pj = $('[data-product-json]'); if (!pj) return;
    var product = JSON.parse(pj.textContent), form = $('[data-main-form]'), sels = $$('[data-option]');
    var mainImg = $('[data-gal-main]');
    function showMedia(id, src) {
      if (mainImg && src) mainImg.src = src;
      $$('[data-media-id]').forEach(function (b) { b.setAttribute('aria-current', String(b.dataset.mediaId) === String(id)); });
    }
    $$('[data-media-id]').forEach(function (b) { b.addEventListener('click', function () { showMedia(b.dataset.mediaId, b.dataset.src); }); });
    function update() {
      var opts = sels.map(function (s) { return s.value; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var btn = $('[data-add-btn]', form), txt = $('[data-btn-text]', form);
      if (!v) { btn.disabled = true; txt.textContent = 'Unavailable'; return; }
      $('input[name=id]', form).value = v.id;
      $('[data-price]').textContent = formatMoney(v.price);
      var sp = $('[data-satc-price]'); if (sp) sp.textContent = formatMoney(v.price);
      var sb = $('[data-satc-btn]'); if (sb) { sb.disabled = !v.available; $('[data-satc-text]', sb).textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var cp = $('[data-compare]'), sv = $('[data-save]');
      if (v.compare_at_price > v.price) {
        cp.textContent = formatMoney(v.compare_at_price); cp.hidden = false;
        if (sv) { sv.textContent = 'You save ' + formatMoney(v.compare_at_price - v.price); sv.hidden = false; }
      } else { cp.hidden = true; if (sv) sv.hidden = true; }
      btn.disabled = !v.available; txt.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_media) {
        var thumb = $('[data-media-id="' + v.featured_media.id + '"]');
        showMedia(v.featured_media.id, thumb ? thumb.dataset.src : null);
      }
      history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
    }
    sels.forEach(function (s) { s.addEventListener('change', update); });

    /* Sticky add-to-cart bar: appears once the main button scrolls out of view */
    var bar = $('[data-satc]'), mainBtn = $('[data-add-btn]', form);
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show);
      }).observe(mainBtn);
      $('[data-satc-btn]', bar).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); paintWish(); });
  document.addEventListener('shopify:block:select', function (e) {
    var sl = e.target.closest('[data-slider]'); if (sl && sl._go) sl._go($$('.slide', sl).indexOf(e.target));
  });

  function init() { initSliders(document); initAnnouncement(); initProduct(); paintWish(); renderWishlistPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
